//git测试网址
const BASE_URL = process.env.VUE_APP_API_URL
export default {
    BASE_URL
}